import { render, staticRenderFns } from "./ViParentReview.vue?vue&type=template&id=5019039c&scoped=true"
import script from "./ViParentReview.vue?vue&type=script&lang=js"
export * from "./ViParentReview.vue?vue&type=script&lang=js"
import style0 from "./ViParentReview.vue?vue&type=style&index=0&id=5019039c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019039c",
  null
  
)

export default component.exports